import axios from 'axios';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { RenderDatePicker, RenderTextArea } from '../../../component/formInput';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import moment from 'moment';

class FinishTransferModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false
    }
  }

  handleOnHide = () => {
    const { onHide, destroy } = this.props;
    destroy();
    onHide();
  }

  submit = () => {
    const { userProduct } = this.props;
    const self = this;
    self.setState({
      isLoading: true
    })
    return axios({
      method: 'post',
      url: window.api_url + '/admin/api/service/finish/transfer',
      data: {
        user_product_id: userProduct.id,
      },
      withCredentials: true
    }).then(function (response) {
      if (!response.data.isError) {
        toast.success("Transfer Tên Miền Hoàn Tất !")
        self.handleOnHide();
      } else {
        toast.error(response.data.error)
      }
      self.setState({
        isLoading: false
      })
    })
  }

  render() {
    const { title, submitting, userProduct } = this.props;
    const { isLoading } = this.state;
    const modalConfig = { backdrop: 'static', show: this.props.show, bssize: "medium", onHide: this.props.onHide, submitting: this.props.submitting };
    return <React.Fragment> 
      {isLoading && <img width="30" src="/assets/img/squares.gif" />}
      {userProduct && !isLoading && <div style={{ width: '30%' }}>
        <ToastContainer />
        <Modal {...modalConfig} aria-labelledby="contained-modal-title-lg">
          <Modal.Header className="bg-warning" closeButton>
            <Modal.Title id="contained-modal-title-sm">{title}</Modal.Title>
          </Modal.Header>
            <Modal.Body>
              <div style={{paddingTop:20}}> 
                <p><strong> Tên Dịch Vụ:  </strong> {userProduct.product && userProduct.product.name}</p>
                <p><strong> Domain / Code:  </strong> {userProduct.domain}</p>
                <p><strong> Ngày Đăng Ký:  </strong> {moment(userProduct.registered).format("DD-MM-YYYY")}</p>
                <p><strong> Ngày Hết Hạn:  </strong> {moment(userProduct.expired).format("DD-MM-YYYY")}</p>
              </div>  
            </Modal.Body>
            <Modal.Footer>
              <div className="text-right">
                <a style={{marginRight: 10}} className="btn" onClick={() => this.handleOnHide()}>Đóng</a>
                <button onClick={() => this.submit()} className="btn bg-warning" disabled={submitting}>Hoàn Tất</button>
              </div>
            </Modal.Footer>
        </Modal>
      </div>}
    </React.Fragment>
  }
}

const mapState = state => ({

});

const mapDispatch = dispatch => ({
    
});

export default (connect(mapState, mapDispatch)(
  reduxForm({
    form: 'FinishTransferModal',
    destroyOnUnmount: true,
    enableReinitialize: true
  })(withRouter(FinishTransferModal))));
